/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Tech_TitleInputs */

const en_about_tech_title = /** @type {(inputs: About_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Technology`)
};

const de_about_tech_title = /** @type {(inputs: About_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsere Technologie`)
};

const fr_about_tech_title = /** @type {(inputs: About_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Technology`)
};

const es_about_tech_title = /** @type {(inputs: About_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Technology`)
};

const it_about_tech_title = /** @type {(inputs: About_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Technology`)
};

const nl_about_tech_title = /** @type {(inputs: About_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Technology`)
};

const pl_about_tech_title = /** @type {(inputs: About_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Technology`)
};

const fi_about_tech_title = /** @type {(inputs: About_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Technology`)
};

const da_about_tech_title = /** @type {(inputs: About_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Technology`)
};

const sv_about_tech_title = /** @type {(inputs: About_Tech_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our Technology`)
};

/**
* | output |
* | --- |
* | "Our Technology" |
*
* @param {About_Tech_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_tech_title = /** @type {((inputs?: About_Tech_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Tech_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_tech_title(inputs)
	if (locale === "fr") return fr_about_tech_title(inputs)
	if (locale === "es") return es_about_tech_title(inputs)
	if (locale === "it") return it_about_tech_title(inputs)
	if (locale === "nl") return nl_about_tech_title(inputs)
	if (locale === "pl") return pl_about_tech_title(inputs)
	if (locale === "fi") return fi_about_tech_title(inputs)
	if (locale === "da") return da_about_tech_title(inputs)
	if (locale === "sv") return sv_about_tech_title(inputs)
	return en_about_tech_title(inputs)
});